import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { HeatingDeviceConfig } from './types';
import { DeviceConfig } from '../../device/config/types';
/**
 * @function
 * Контекст конфигурации отопительного устройства
 * @param children - другие контексты для вкладки отопления
 */
export const HeatingDeviceConfigProvider = memo(function HeatingDeviceConfigProvider(props) {
    const { children } = props;
    const { device_ui_settings } = useContext(DeviceConfig);
    const heating_modes_icons = useMemo(() => device_ui_settings.icons?.heating_modes, [device_ui_settings]);
    const heating_circuits_icons = useMemo(() => device_ui_settings.icons?.heating_circuits, [device_ui_settings]);
    const boiler_heating_circuits_icons = useMemo(() => device_ui_settings.icons?.boiler_heating_circuits, [device_ui_settings]);
    const web_elements_icons = useMemo(() => device_ui_settings.icons?.web_elements, [device_ui_settings]);
    const device_config_context = useMemo(() => ({
        heating_circuits_icons,
        heating_modes_icons,
        boiler_heating_circuits_icons,
        web_elements_icons,
    }), [
        heating_circuits_icons,
        heating_modes_icons,
        boiler_heating_circuits_icons,
        web_elements_icons,
    ]);
    return (_jsx(HeatingDeviceConfig.Provider, { value: device_config_context, children: children }));
});
export const useHeatingDeviceConfig = () => useContext(HeatingDeviceConfig);
